import React, { useState } from 'react';
import { Alert, Button, Modal, Space, Upload } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import { importTaobaoOrderReport } from '../../api/taobaoIntegration';

const ChannelOrderImportDialog = ({ open, onClose, onImported }) => {
  const [reportFile, setReportFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const resetAndClose = () => {
    if (importing) return;
    setReportFile(null);
    setResult(null);
    setError('');
    onClose();
  };

  const importReport = async () => {
    if (!reportFile) return;
    setImporting(true);
    setError('');
    setResult(null);
    try {
      const nextResult = await importTaobaoOrderReport(reportFile);
      setResult(nextResult);
      setReportFile(null);
      await onImported?.();
    } catch (nextError) {
      setError(nextError?.message || '渠道订单明细导入失败');
    } finally {
      setImporting(false);
    }
  };

  return (
    <Modal
      open={open}
      title="导入淘宝渠道订单"
      footer={null}
      onCancel={resetAndClose}
      closable={!importing}
      maskClosable={!importing}
      destroyOnHidden
    >
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Upload
          accept=".csv,text/csv"
          maxCount={1}
          beforeUpload={(file) => {
            setReportFile(file);
            setResult(null);
            setError('');
            return false;
          }}
          onRemove={() => {
            setReportFile(null);
            return true;
          }}
          fileList={reportFile ? [reportFile] : []}
        >
          <Button icon={<CloudUploadOutlined />}>选择渠道订单明细</Button>
        </Upload>

        {error ? <Alert showIcon type="error" message={error} /> : null}
        {result ? (
          <Alert
            showIcon
            type="success"
            message={result.message || '渠道订单明细导入完成'}
            description={`新增 ${result.createdCount || 0}，更新 ${result.updatedCount || 0}，返利处理 ${(result.rebateCreatedCount || 0) + (result.rebateUpdatedCount || 0)}，未归因 ${result.unmatchedCount || 0}，跳过 ${result.rejectedCount || 0}`}
          />
        ) : null}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button disabled={importing} onClick={resetAndClose}>关闭</Button>
          <Button
            type="primary"
            icon={<CloudUploadOutlined />}
            disabled={!reportFile}
            loading={importing}
            onClick={importReport}
          >
            开始导入
          </Button>
        </div>
      </Space>
    </Modal>
  );
};

export default ChannelOrderImportDialog;
